import React, { useState, useEffect } from "react";
import axiosInstance from "../helpers/axios";
import { useSearchParams } from "react-router-dom";
import { Typography, Button } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";

const CollectLocationForm = () => {
  const [searchParams] = useSearchParams();
  const psid = searchParams.get("psid");
  const pageId = searchParams.get("pageId");
  const flowId = searchParams.get("flowId");
  const [loading, setLoading] = useState(false);
  const [greeting, setGreeting] = useState("");
  const { Title, Text } = Typography;

  useEffect(() => {
    // Set greeting based on time
    const hour = new Date().getHours();
    setGreeting(
      hour < 12
        ? "Good Morning!"
        : hour < 18
        ? "Good Afternoon!"
        : "Good Evening!"
    );
  }, []);

  // useEffect(() => {
  //   if (!psid || !pageId) return;

  //   const requestLocation = async () => {
  //     try {
  //       const permissionStatus = await navigator.permissions.query({
  //         name: "geolocation",
  //       });

  //       if (permissionStatus.state === "granted") {
  //         getLocation();
  //       } else if (permissionStatus.state === "prompt") {
  //         navigator.geolocation.getCurrentPosition(
  //           getLocation, // No need for an extra function call
  //           () => setLoading(false)
  //         );
  //       }
  //     } catch (error) {
  //       console.error("Error checking location permission:", error);
  //     }
  //   };

  //   requestLocation();
  // }, [pageId, psid]);

  // const getLocation = () => {
  //   setLoading(true);
  //   navigator.geolocation.getCurrentPosition(
  //     async ({ coords: { latitude, longitude } }) => {
  //       try {
  //         const response = axiosInstance().post(
  //           "https://preprod.dorydelivery.com/api/orders/save-customer-location",
  //           { psid, latitude, longitude, flowId }
  //         );

  //         // if (response.status === 201) {
  //         //   console.log("Location data saved successfully");
  //         redirectToMessenger();
  //         // } else {
  //         //   console.error("Failed to save location data");
  //         // }
  //       } catch (error) {
  //         console.error("Error during location data submission:", error);
  //       } finally {
  //         setLoading(false);
  //       }
  //     },
  //     (error) => {
  //       setLoading(false);
  //       alert(
  //         error.code === error.PERMISSION_DENIED
  //           ? "Location permission is required. Please allow location access."
  //           : "An error occurred while accessing your location."
  //       );
  //     }
  //   );
  // };

  const getLocation = () => {
    setLoading(true);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          try {
            const response = await axiosInstance().post(
              "https://api.dorydelivery.com/api/orders/save-customer-location",
              {
                psid,
                latitude,
                longitude,
                flowId,
              }
            );

            if (response.status === 201) {
              const userAgent = navigator.userAgent.toLowerCase();
              const isAndroid = /android/i.test(userAgent);
              const isIOS = /iphone|ipad|ipod/i.test(userAgent);

              if (isAndroid) {
                const messengerUrl = `intent://m.me/${pageId}#Intent;package=com.facebook.orca;scheme=https;end;`;
                window.location.href = messengerUrl;

                setTimeout(() => {
                  window.close();
                }, 500);
              } else if (isIOS) {
                const messengerUrl = `fb-messenger://user-thread/${pageId}`;
                window.location.href = messengerUrl;

                setTimeout(() => {
                  if (window.opener) {
                    window.close();
                  }
                }, 500);
              } else {
                window.location.href = `https://m.me/${pageId}`;
              }
            } else {
              console.error("Failed to save location data");
            }
          } catch (error) {
            console.error("Error during location data submission:", error);
          } finally {
            setLoading(false);
          }
        },
        (error) => {
          setLoading(false);
          if (error.code === error.PERMISSION_DENIED) {
            alert(
              "Location permission is required for this feature. Please allow location access."
            );
          } else {
            alert("An error occurred while accessing your location.");
          }
        }
      );
    } else {
      setLoading(false);
      alert("Geolocation is not supported by this browser.");
    }
  };

  // const redirectToMessenger = () => {
  //   const userAgent = navigator.userAgent.toLowerCase();
  //   const isAndroid = /android/i.test(userAgent);
  //   const isIOS = /iphone|ipad|ipod/i.test(userAgent);
  //   const messengerUrl = isAndroid
  //     ? `intent://m.me/${pageId}#Intent;package=com.facebook.orca;scheme=https;end;`
  //     : isIOS
  //     ? `fb-messenger://user-thread/${pageId}`
  //     : `https://m.me/${pageId}`;

  //   window.location.href = messengerUrl;
  //   setTimeout(() => window.close(), 500);
  // };

  return (
    <>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <Title
          level={2}
          style={{
            position: "relative",
            zIndex: 1,
            marginBottom: 0,
          }}
        >
          {greeting}
        </Title>
        <Text
          style={{
            fontWeight: "bold",
            color: "#00f57f",
            fontSize: 24,
            marginLeft: 16,
            marginBottom: 16,
          }}
        >
          Please share your location.
        </Text>
        <div style={{ marginTop: "30px" }}>
          <Button
            onClick={getLocation}
            type="primary"
            loading={loading}
            icon={<EnvironmentOutlined />}
            size="large"
            style={{
              height: 80,
              padding: "20px 30px",
              fontSize: "20px",
              backgroundColor: "black",
              color: "white",
              borderColor: "black",
              width: "250px",
            }}
          >
            {loading ? "Locating..." : "Share Location"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default CollectLocationForm;
